export * from './cupom'
export * from './usuario'
export * from './disciplina'
export * from './professor'
export * from './turma'
export * from './aluno'
export * from './curso'
export * from './historico'
export * from './relatorio'
export * from './ticket'
export * from './documentos-certificacao-fila'
export * from './parceiro-certificacao'
export * from './requerimento'
export * from './background-services'
export * from './auditoria'
